import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";

function Login({ setUserName, setUserRole }) {
  const navigate = useNavigate();

  const [backendUrl, setBackendUrl] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");

  // Load backend URL from config.js
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.onload = () => {
      if (window.env?.BACKEND_URL) {
        setBackendUrl(window.env.BACKEND_URL);
      } else {
        console.error("BACKEND_URL not found in config.js");
      }
    };
    document.body.appendChild(script);
  }, []);

  // ---------------- LOGIN ----------------
  const handleLogin = async (e) => {
    e.preventDefault();

    if (!backendUrl) {
      setMessage("Configuration not loaded yet. Try again.");
      return;
    }

    try {
      const response = await axios.post(`${backendUrl}/login`, {
        email,
        password,
      });

      const data = response.data;

      // Backend contract (authoritative)
      const userNameFromDB = data.Username;
      const roles = Array.isArray(data.roles) ? data.roles : [data.role];
      const primaryRole = roles[0];

      // ---------------- SAVE SESSION ----------------
      localStorage.setItem("token", data.token);
      localStorage.setItem("userId", data.userId);
      localStorage.setItem("userName", userNameFromDB);
      localStorage.setItem("roles", JSON.stringify(roles));
      localStorage.setItem("activeRole", primaryRole);

      // Instructor specific
      if (roles.includes("Instructor")) {
        localStorage.setItem("instructorId", data.userId);
      } else {
        localStorage.removeItem("instructorId");
      }

      // Update app state
      setUserName(userNameFromDB);
      setUserRole(primaryRole);

      // Clear old errors
      setMessage("");

      // Welcome message
      alert(`Welcome ${userNameFromDB}! Logged in as ${primaryRole}.`);

      // Redirect
     // Redirect AFTER state & storage are set
    setTimeout(() => {
    if (primaryRole === "Admin") {
     navigate("/dashboard/admin", { replace: true });
     } else if (primaryRole === "Instructor") {
        navigate("/dashboard/instructor", {
        replace: true,
       state: { instructorId: data.userId },
        });
      } else {
        navigate("/dashboard/student", { replace: true });
     }
  }, 0);


      // Clear fields
      setEmail("");
      setPassword("");
    } catch (error) {
      console.error("Login error:", error);

      if (error.response?.status === 401) {
        setMessage("Invalid email or password");
      } else if (error.response?.status === 403) {
        setMessage("Please verify your email before logging in.");
      } else {
        setMessage("Login failed. Please try again later.");
      }
    }
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Login</h2>

      <form className="login-form" onSubmit={handleLogin}>
        <label>Email:</label>
        <input
          type="email"
          className="input-field"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Password:</label>
        <input
          type="password"
          className="input-field"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <div className="login-button-group">
          <button type="submit" className="btn submit-btn">
            Login
          </button>

          <button
            type="button"
            className="btn back-btn"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password
          </button>
        </div>
      </form>

      {message && <p style={{ color: "red", marginTop: "10px" }}>{message}</p>}
    </div>
  );
}

export default Login;
